import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { environment } from "../../environments/environment";
import { CutoffConfig } from "../models/cutoff-config";
import { PagedResult } from "../models/paged-result";

@Injectable({ providedIn: 'root' })
export class ConfigurationNfService {
  private readonly baseUrl = `${environment.apis.unified.baseUrl}/configuration-nf`;

  constructor(private http: HttpClient) { }

  getAll(params: any, skipGlobalErrors = true): Observable<PagedResult<CutoffConfig>> {
    const headers = skipGlobalErrors ? new HttpHeaders({ 'X-Skip-Error-Handler': 'true' }) : undefined;
    return this.http.get<PagedResult<CutoffConfig>>(this.baseUrl, { params, headers });
  }

  create(data: any, skipGlobalErrors = true) {
    const headers = skipGlobalErrors ? new HttpHeaders({ 'X-Skip-Error-Handler': 'true' }) : undefined;
    return this.http.post(this.baseUrl, data, { headers });
  }

  update(id: string, data: any, skipGlobalErrors = true) {
    const headers = skipGlobalErrors ? new HttpHeaders({ 'X-Skip-Error-Handler': 'true' }) : undefined;
    return this.http.put(`${this.baseUrl}/${id}`, data, { headers });
  }

  delete(id: string, skipGlobalErrors = true) {
    const headers = skipGlobalErrors ? new HttpHeaders({ 'X-Skip-Error-Handler': 'true' }) : undefined;
    return this.http.delete(`${this.baseUrl}/${id}`, { headers });
  }
}
